
import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { APP_CONFIG } from '@/config/app-config';

import authService from '@/services/auth-services';

import { Customer } from '@/models/customer';

import ProfileLeft from './components/ProfileLeft.vue';
import ProfileRight from './components/ProfileRight.vue';

@Component({
    components: {
        Loading,
        'profile-left': ProfileLeft,
        'profile-right': ProfileRight
    }
})
export default class Profile extends Vue {
    private isLoading = false;

    private customer: Customer = {};
    private submitForm: any = null;

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    constructor() {
        super();
    }

    private async created() {
        this.isLoading = true;
        await this.getCustomersInfo();
        this.isLoading = false;
    }

    private async submit() {
        const handle =  async () => {
            this.isLoading = true;
            const dataRequest = {
                Username: this.customer.UserName,
                SaleID: this.customer.SaleID,
                BuyerID: this.customer.BuyerID,
                CustomerServiceID: this.customer.CustomerServiceID,
                PhonePrefix: this.customer.PhonePrefix,
                PhoneNumber: this.customer.PhoneNumber,
                Email: this.customer.Email,
                Address: this.customer.Address,
                FirstName: this.customer.FirstName,
                LastName: this.customer.LastName,
                ReceivePlaceID: this.customer.ReceivePlaceID,
                Password: this.customer.Password
            };

            const result = await authService.updateCustomersInfo(this.userInfo.userId, dataRequest);

            if (result && result.status === 200 && result.data.message === 'Success') {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Bạn đã cập nhật thành công!',
                });
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', { ...this.customer } || {});
            }

            this.isLoading = false;
        }
        
        this.submitForm = handle;
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
                this.customer = {
                    ...result.data.data,
                    UserName: result.data.data.Username,
                    Password: '',
                    RePassword: ''
                };
            }
        }
    }
}
